<template>
    <div>
        <div class="item-container profession-add-form popup-shadow" :class="getClasses">
            <div class="tab-header-container">
                <h2 class="form-label">{{profession ? 'Редактиране' : 'Добавяне'}} на професия</h2>
                <LiteButton @click.native="close"
                            v-show="profession && profession.id"
                            style="font-size: 35px; float: right;"
                            class="edit-button"
                            :hoverColor="'red'"
                            :icon="'far fa-window-close'">
                </LiteButton>
            </div>

            <hr class="form-line">

            <form>
                <InputText class="profession-input"
                           @value-change="setAttribute"
                           :id="'name'"
                           :name="'name'"
                           :label="'Име'"
                           :initialValue="profession ? profession.name : null"
                           :placeholder="'Въведете име'"
                           :newValue="newProfession.name"
                           :showError="shouldShowError('name')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('name')" :text="errors['name']"></ErrorInput>

                <InputText class="profession-input"
                           @value-change="setAttribute"
                           :id="'code'"
                           :name="'code'"
                           :label="'Код'"
                           :initialValue="profession ? profession.code : null"
                           :placeholder="'Въведете код'"
                           :newValue="newProfession.code"
                           :showError="shouldShowError('code')">
                </InputText>
                <ErrorInput class="error" v-if="shouldShowError('code')" :text="errors['code']"></ErrorInput>

                <Button class="save-profession-button"
                        @click.native="saveProfession"
                        :color="'green'"
                        :text="'Запази'"
                        :icon="'fa fa-save'"></Button>
            </form>
        </div>
    </div>
</template>

<script>
    import professionGridConfig from "@/components/worker/profession-list-grid.config";
    import Button from "@/shared/components/button/Button";
    import ErrorInput from "@/shared/components/form/ErrorInput";
    import sharedService from "@/services/shared.service";
    import InputText from "@/shared/components/form/InputText";
    import LiteButton from "@/shared/components/button/LiteButton";

    export default {
        name: "ProfessionEdit",
        components: {LiteButton, InputText, Button, ErrorInput},
        props: {
            profession: Object
        },
        created() {
            if (this.profession && this.profession.id) {
                this.newProfession = this.profession;
            }
        },
        data() {
            return {
                config: professionGridConfig,
                gridData: [],
                isLoading: true,
                newProfession: {
                    name: null,
                    code: null
                },
                errors: {}
            }
        },
        methods: {
            setAttribute(value) {
                this.errors[value.name] = null;
                this.newProfession[value.name] = value.currentValue;
            },
            saveProfession() {
                if (this.profession && this.profession.id) {
                    sharedService.updateProfession(this.newProfession)
                        .then(() => {
                            this.professionSaved()
                        })
                        .catch((errors) => this.errors = errors.response.data.errors);

                } else {
                    sharedService.addProfession(this.newProfession)
                        .then(() => {
                            this.professionSaved()
                        })
                        .catch((errors) => this.errors = errors.response.data.errors);
                }
            },
            shouldShowError(fieldName) {
                return !!(this.errors && this.errors[fieldName]);
            },
            professionSaved() {
                this.$emit('saved-profession');
                this.newProfession = {name: '', code: ''};
            },
            close() {
                this.$emit('close-clicked', {});
            }
        },
        computed: {
            getClasses() {
                return this.profession && this.profession.id ? 'profession-modal-form' : '';
            }
        }
    }
</script>

<style scoped>
    @import '../../css/shared/tabs.css';

    .profession-modal-form {
        z-index: 120;
        position: absolute;
        background-color: #ffffff;
        top: 100px;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .profession-input {
        width: 500px;
        height: 95px;
        margin: 20px auto 0 auto;
    }

    .save-profession-button {
        width: 220px;
        height: 50px;
        font-size: 25px;
        margin: 45px;
    }

    .profession-add-form {
        width: 600px;
    }

    .error {
        width: 500px;
        margin-top: -7px;
    }
</style>
